import { FC, useCallback, useEffect, useState } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Card, Svg, Typography } from '@altermaind/web/ui';
import { useBreakingPoints } from '@/_shared/hooks/useBreakpoint';
import { useDialog } from '@/_shared/hooks/useDialog';
import { DialogEditImportedProfilesPayload } from '../DialogEditImportedProfiles';

type Props = {
  incompleteData: { fieldName: string; code: string; affectedEmployee: number };
};

export const CardsIncompleteData: FC<Props> = ({ incompleteData }) => {
  const t = useTranslations('configuration.hr.verifyData.previewDataWarning.incompleteData');

  const { isDesktop } = useBreakingPoints();

  const [showCta, setShowCta] = useState(false);
  const { openDialog: openDialogEdit } = useDialog<DialogEditImportedProfilesPayload>(
    'uploadCompanyDataEditImportedProfiles',
  );

  const onViewDetail = useCallback(() => {
    openDialogEdit({ filters: { issueFields: [incompleteData.fieldName] } });
  }, [incompleteData.fieldName, openDialogEdit]);

  useEffect(() => {
    if (!isDesktop) {
      setShowCta(true);
    }
  }, [isDesktop]);

  return (
    <Box
      display='flex'
      flex={1}
      onMouseEnter={isDesktop ? () => setShowCta(true) : undefined}
      onMouseLeave={isDesktop ? () => setShowCta(false) : undefined}
      style={{
        cursor: 'pointer',
      }}
      onClick={isDesktop ? undefined : onViewDetail}
    >
      <Card
        width='100%'
        height='100%'
        display='flex'
        flex={1}
        p='s'
        flexDirection='row'
        borderWidth={1}
        borderStyle='solid'
        borderColor='primary/text'
      >
        <Box
          display='flex'
          flexDirection='row'
          flex={0}
          borderRadius={100}
          bg='error'
          p='xxxs'
          size='m'
          mr='xs'
        >
          <Svg fill='white' name='close' size='s' />
        </Box>
        <Box display='flex' flexDirection='column' flex={1} justifyContent='flex-start'>
          <Typography variant='p1/bold' mb='none' style={{ lineBreak: 'anywhere' }}>
            {t(`fieldKeys.${incompleteData.fieldName}`)}
          </Typography>
          <Box display='flex' flex={1}>
            <Typography variant='p2/light' color='grey/light'>
              {incompleteData.affectedEmployee && incompleteData.affectedEmployee > 1
                ? t('message.plural', {
                    count: incompleteData.affectedEmployee,
                  })
                : t('message.singular')}
            </Typography>
          </Box>
        </Box>
        <Box
          display='flex'
          flexDirection='row'
          flex={0}
          justifyContent='flex-end'
          alignItems='center'
        >
          <Box
            display='flex'
            alignItems='center'
            onClick={showCta ? onViewDetail : undefined}
            style={{
              cursor: 'pointer',
            }}
            ml='xs'
          >
            <Svg name='edit' stroke={showCta ? 'primary/text' : 'transparent'} size='s' />
          </Box>
        </Box>
      </Card>
    </Box>
  );
};
